// prefix
export const PREFIX_CLS = "ve-icon-";

// emit events
export const EMIT_EVENTS = {};

// comps name
export const COMPS_NAME = {
    VE_ICON: "VeIcon",
};
